import React from 'react';
import parse from 'html-react-parser';
import { markdown } from '../../../common/markdown';
import { AllieTextWrapperMessage } from '../ChatResponse/ChatResponse.styles';
import { replaceMarkdownTable } from './markdownTableReplace';

interface MarkdownTextProps {
  content: string;
  onDownloadCsv?: (csvData: string) => void;
  downloadCsvTooltip?: string;
  onDownloadXlsx?: (csvData: string) => void;
}

export const MarkdownText: React.FC<MarkdownTextProps> = ({
  content,
  onDownloadCsv,
  downloadCsvTooltip,
  onDownloadXlsx,
}) => {
  const htmlString = markdown.parse(content || '') as string;

  const options: Parameters<typeof parse>[1] = {
    replace: (domNode) =>
      replaceMarkdownTable(domNode, options, {
        onDownloadCsv,
        downloadCsvTooltip,
        onDownloadXlsx,
      }),
  };

  return (
    <AllieTextWrapperMessage type="body1" color="neutral-70">
      {parse(htmlString, options)}
    </AllieTextWrapperMessage>
  );
};
